import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer: React.FC = () => {
    return (
        <Box
        component="footer"
        sx={{
          textAlign: 'center',
          backgroundColor: 'background.default',
          color: 'text.secondary',
          display: 'flex', 
          justifyContent: 'center', 
          flexDirection: 'row', 
          alignItems: 'center',
          gap: 1
        }}
      >
        &copy; {new Date().getFullYear()} 
            <Typography variant="body2" display="block" gutterBottom sx={{mt: '5px', }}>
                Dezign 
            </Typography>
            <Typography variant="body2" display="block" gutterBottom sx={{ color: 'red', mt: '5px', }}>
                Shark
            </Typography>
            <Typography variant="body2" display="block" gutterBottom sx={{mt: '5px', }}>
                All rights reserved.
            </Typography>
        </Box>
    );
};

export default Footer;